module.exports = __webpack_public_path__ + "static/media/codingOutside.7c178241.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/codingOutside.jpg
// module id = 754
// module chunks = 1 3